<template>
  <ui-modal-layout :title="tr('Payment details')" :icon="ReceiptIcon">
    <dl class="m-0 flex flex-col divide-y divide-border">
      <div class="flex items-center justify-between gap-3 py-2">
        <dt class="text-muted-foreground">{{ tr('Date') }}</dt>
        <dd class="m-0 font-medium tabular-nums">{{ formatToYMD(paymentHistory.created_at) }}</dd>
      </div>
      <div class="flex items-center justify-between gap-3 py-2">
        <dt class="text-muted-foreground">{{ tr('Status') }}</dt>
        <dd class="m-0">
          <ui-badge :variant="paymentHistory.status === 'success' ? 'success' : paymentHistory.status === 'failed' ? 'destructive' : 'secondary'">
            {{ tr(paymentHistory.status) }}
          </ui-badge>
        </dd>
      </div>
      <div v-if="paymentHistory.fail_reason" class="flex items-center justify-between gap-3 py-2">
        <dt class="text-muted-foreground">{{ tr('Fail reason') }}</dt>
        <dd class="m-0 text-right font-medium">{{ paymentHistory.fail_reason }}</dd>
      </div>
    </dl>

    <payment-history-details :entity="paymentHistory" />

    <template v-if="hasAction" #footer>
      <ui-button v-if="paymentHistory.invoice_number" :disabled="isDownloading" @click="() => downloadInvoice()">
        <loader-circle-icon v-if="isDownloading" class="animate-spin" />
        <download-icon v-else />
        {{ tr('Download invoice') }}
      </ui-button>
      <ui-button v-else-if="paymentHistory.can_pay_now" @click="() => payNow()">
        <credit-card-icon />
        {{ tr('Pay now') }}
      </ui-button>
    </template>
  </ui-modal-layout>
</template>

<script>
import {
  CreditCard,
  Download,
  LoaderCircle,
  Receipt,
} from '@lucide/vue';
import { markRaw } from 'vue';

import PaymentHistoryService from '@/services/PaymentHistory';
import PaymentHistoryDetails from '@/ui/components/PaymentHistoryDetails.vue';
import PaymentModal from '@/ui/components/PaymentModal.vue';
import { formatToYMD } from '@/utils/date';

export default {
  name: 'PaymentHistoryDetailsModal',
  components: {
    CreditCardIcon: CreditCard,
    DownloadIcon: Download,
    LoaderCircleIcon: LoaderCircle,
    PaymentHistoryDetails,
  },
  props: {
    paymentHistory: {
      type: Object,
      required: true,
    },
    invoiceDownloading: {
      type: [ String, Number ],
      required: false,
      default: null,
    },
  },
  data: () => ({
    ReceiptIcon: markRaw(Receipt),
    isDownloading: false,
  }),
  computed: {
    hasAction() {
      return !!this.paymentHistory.invoice_number || !!this.paymentHistory.can_pay_now;
    },
  },
  methods: {
    formatToYMD,
    downloadInvoice() {
      if (this.invoiceDownloading) {
        return;
      }

      this.isDownloading = true;

      PaymentHistoryService.downloadInvoice(this.paymentHistory.id, this.paymentHistory.invoice_number + '.pdf')
        .catch(err => this.error(err))
        .finally(() => this.isDownloading = false);
    },
    payNow() {
      this.$fullscreenModal.open(
        this,
        PaymentModal,
        { paymentHistory: this.paymentHistory },
      );
    },
  },
};
</script>
